import { MDBBadge, MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import copyToClipboard from "../../utils/copyToClipboard";
import { generatePdfFileName } from "../../utils/generatePdfFileName";
import { useDarkMode } from "../assets/DarkModeContext";
import { cloneResume, deleteResume } from "../services/httpService";
import { toast } from 'react-toastify';

export default function ResumeListItem( { resume, index, user, refresh } ) {
    const [ showBadge, setShowBadge ] = useState( false );
    const { isDarkMode } = useDarkMode();

    const keywords = resume.properties?.keywords || [];
    const resumeLanguage = resume?.properties?.documentLanguage || "fr";

    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    function handleDelete() {
        const confirmed = window.confirm( "Êtes-vous sûr de vouloir supprimer ce CV ?" );
        if ( !confirmed ) {
            return;
        }

        deleteResume( resume.id )
            .then( ( response ) => {
                if ( response.ok ) {
                    
                    //setUserResumes( userResumes.filter( ( r ) => resume.id !== r.Id ) );
                    refresh();
                } else {
                    console.error( "Erreur lors de la suppression du CV :", response );
                    toast.error("Erreur lors de la suppression du CV");
                }
            } )
            .catch( ( error ) => console.error( error ) );
    }

    async function handleClone() {
        cloneResume( resume.id )
            .then( ( response ) => {
                if ( !response.ok ) {
                    throw new Error( `HTTP error! status: ${ response.status }` );
                }
                const clonedResume = response.json();
                
                //setUserResumes( ( resumes ) => [ ...resumes, clonedResume ] );
                refresh();
            } )
            .catch( ( error ) => {
                console.error(
                    "There was a problem with the fetch operation: " + error.message
                );
            } )
    }

    function handleCopyPdfLink() {

        const filename = generatePdfFileName( user, resumeLanguage, keywords );

        const fullPdfUrl = `${ baseUrl }resumes/pdf-uploads/${ encodeURIComponent( filename ) }`;

        copyToClipboard( fullPdfUrl );

        setShowBadge( true );

        setTimeout( () => {
            setShowBadge( false );
        }, 3000 );
    }

    function handlePdfPreview() {
        const previewUrl = `/cv-preview/${ user.id }/${ resume.id }`;
        window.open( previewUrl, '_blank', 'noopener,noreferrer' );
    }

    function handleEmailShare() {
        const filename = generatePdfFileName( user, resumeLanguage, keywords );
        const fullPdfUrl = `${ baseUrl }resumes/pdf-uploads/${ encodeURIComponent( filename ) }`;
        const subject = encodeURIComponent( "Lien vers mon CV" );
        const body = encodeURIComponent( `Consultez mon CV ici: ${ fullPdfUrl }` );
         window.open( `mailto:?subject=${ subject }&body=${ body }`, "_blank" );
    }

    return (
        <tr
            key={ index }
            className={ isDarkMode ? "text-white" : "text-muted" }
        >
            <td>
                <div className="d-flex align-items-center">
                    <img
                        src={ './spinner-alcyone.png' }
                        alt=""
                        style={ { width: "45px", height: "45px" } }
                        className="rounded-circle"
                    />
                    <Link
                        to={ `/mon-espace-cv/${ user.id }/${ resume.id }` }
                        style={ { cursor: "pointer" } }
                    >
                        <MDBBadge color="info" light>
                            ACO_{ user.prenom ? user.prenom : "-" }_<span
                                className="text-uppercase"
                            >{ user.nom ? user.nom : "-" }</span>_CV_<span
                                className="text-uppercase"
                            >{ resume.properties.documentLanguage ? resume.properties.documentLanguage : "-" }</span>
                        </MDBBadge>
                    </Link>
                </div>
            </td>
            <td>
                <div className="text-center">
                    { resume.properties.isAnonymous ? (
                        <MDBIcon
                            fas
                            icon="user-secret"
                            size="lg"
                            style={ { color: "#09B4BF" } }
                            title="oui"
                        />
                    ) : (
                        <MDBIcon
                            fas
                            icon="user-alt"
                            size="lg"
                            style={ { color: "#09B4BF" } }
                            title="non"
                        />
                    ) }
                </div>
            </td>
            <td>
                <p className="mb-0">{ keywords && keywords.length > 0 ? keywords?.join( ', ' ) : 'pas de mot clef' }</p>
            </td>
            <td>
                <p className="fw-normal mb-1 text-uppercase">
                    { resume.properties.documentLanguage }
                </p>
            </td>
            <td>
                <p className="fw-normal mb-1">
                    { new Date( resume.creationDate ).toLocaleDateString(
                        "fr-FR"
                    ) }
                </p>
            </td>
            <td>
                <p className="fw-normal mb-1">
                    { resume.lastModificationDate && resume.lastModificationDate !== 0
                        ? new Date( resume.lastModificationDate ).toLocaleDateString(
                            "fr-FR"
                        )
                        : "-" }
                </p>
            </td>
            <td>
                <MDBBadge
                    light
                    color={ ( () => {
                        switch ( resume.status ) {
                            case "VALIDE":
                                return 'success';
                            case "BROUILLON":
                                return 'warning';
                            case "NON_COMMENCE":
                                return 'danger';
                            default:
                                return 'secondary';
                        }
                    } )() }
                    pill
                >
                    { resume.status }
                </MDBBadge>
            </td>

            <td>
                <div className="d-flex">
                    { user && resume && (
                        <Link
                            to={ `/mon-espace-cv/${ user.id }/${ resume.id }` }>
                            <MDBBtn
                                className="fw-bold"
                                color="link"
                                rounded
                                size="sm"
                                rippleColor="dark"
                                title="Éditer le CV"
                            >
                                <MDBIcon fas icon="edit"/>
                            </MDBBtn>
                        </Link>
                    ) }
                    <div style={ { position: "relative" } }>
                        <MDBBtn
                            className="fw-bold"
                            color="link"
                            rounded
                            size="sm"
                            rippleColor="dark"
                            title="Copier lien"
                            onClick={ handleCopyPdfLink }
                        >
                            <MDBIcon far icon="clone"/>
                        </MDBBtn>
                        { showBadge && (
                            <MDBBadge
                                color="info"
                                className="position-absolute"
                                style={ { top: "10px", right: "10px" } }
                            >
                                Lien copié !
                            </MDBBadge>
                        ) }
                    </div>
                    <MDBBtn
                        className="fw-bold"
                        color="link"
                        rounded
                        size="sm"
                        rippleColor="dark"
                        title="Cloner"
                        onClick={ handleClone }
                    >
                        <MDBIcon far icon="copy"/>
                    </MDBBtn>
                </div>
                <MDBBtn
                    className="fw-bold"
                    color="link"
                    rounded
                    size="sm"
                    rippleColor="dark"
                    title="Effacer"
                    onClick={ handleDelete }
                >
                    <MDBIcon far icon="trash-alt"/>
                </MDBBtn>
                <MDBBtn
                    className="fw-bold"
                    color="link"
                    rounded
                    size="sm"
                    rippleColor="dark"
                    title="Partager"
                    onClick={ handleEmailShare }
                >
                    <MDBIcon fas icon="share-square"/>
                </MDBBtn>
                <MDBBtn
                    className="fw-bold"
                    color="link"
                    rounded
                    size="sm"
                    rippleColor="dark"
                    title="Prévisualiser"
                    onClick={ handlePdfPreview }
                >
                    <MDBIcon far icon="eye"/>
                </MDBBtn>
            </td>
        </tr>
    );
}

ResumeListItem.propTypes = {
    resume: PropTypes.any.isRequired,
    index: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
};
